import { colors } from './colorsPallete'

interface StatusInfo {
  bgcolor: string
  text: string
}

const DEFAULT_STATUS_INFO: StatusInfo = {
  bgcolor: colors['gray.600'],
  text: 'Sem Regra',
}

export const STATUS_MAPPING: { [key: string]: StatusInfo } = {
  Recebido: { bgcolor: colors.blue, text: 'Recebido' },
  Pago: { bgcolor: colors['green.default'], text: 'Pago' },
  'Não Recebido': { bgcolor: colors.error, text: 'Não Recebido' },
  'Não repassado': { bgcolor: colors.blue, text: 'Não repassado' },
  'Outra Via': { bgcolor: colors['gray.600'], text: 'Outra Via' },
  Faturado: { bgcolor: colors['blue.light'], text: 'Faturado' },
  Glosado: { bgcolor: colors.warn, text: 'Glosado' },
  Atrasado: { bgcolor: '#FF1050', text: 'Atrasado' },
  'Em análise': { bgcolor: '#E96338', text: 'Em Análise' },
  Repassado: { bgcolor: colors['green.default'], text: 'Repassado' },
  REPASSADO: { bgcolor: colors['green.default'], text: 'Repassado' },
  'A Repassar': { bgcolor: colors.blue, text: 'A Repassar' },
  'Sem Regra': { bgcolor: colors['gray.600'], text: 'Sem Regra' },
  'Não Faturado': { bgcolor: colors.error, text: 'Não Faturado' },
  '': DEFAULT_STATUS_INFO,
}

/**
 * Returns the status information based on the status string.
 * If the status is not found, it returns the default status information.
 *
 * @param status
 * @returns StatusInfo interface
 */
export function getStatusInfo(status: string): StatusInfo {
  return STATUS_MAPPING[status] || DEFAULT_STATUS_INFO
}

export function getMedicalProductionStatus(attributes: {
  institution_status?: string | null
  status?: string | null
  secondary_status?: string | null
}): string {
  const rawStatus = attributes?.institution_status || attributes?.status || attributes?.secondary_status || ''
  const normalizedStatus = rawStatus.trim()

  if (normalizedStatus.toLowerCase() === 'não repassado') return 'Não repassado'
  if (normalizedStatus.toLowerCase() === 'nao repassado') return 'Não repassado'

  return normalizedStatus
}
